import React from 'react'
import PropTypes from 'prop-types'
import {
  MProductItem,
  CartProvider,
  CheckoutProvider,
  ProductProvider,
} from '../../common/ecommerce'

import { MTicketAccessCode } from '../types'

import { PasswordProvider } from '../contexts/PasswordContext'
import EcommercePasswordPage from './EcommercePasswordPage'

const TicketsPage = ({products, accessCode, ...rest}) => (
  <ProductProvider>
    <CartProvider>
      <CheckoutProvider>
        <PasswordProvider>
            <EcommercePasswordPage products={products} accessCode={accessCode} {...rest} />
        </PasswordProvider>
      </CheckoutProvider>
    </CartProvider>
  </ProductProvider>
)

TicketsPage.propTypes = {
  products: PropTypes.arrayOf(MProductItem),
  accessCode: MTicketAccessCode,
}

export default TicketsPage
